module.exports = __webpack_public_path__ + "img/8.acdd72c4.png";